module.exports = __webpack_public_path__ + "public/SiteImages/noResultImage.svg?52b7d023";